<script setup>
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import { useKeenSlider } from 'keen-slider/vue';

defineProps({
    title: String,
    logos: Array,
    addOnLabel: Boolean,
    background_color: String,
});

const [container] = useKeenSlider(
    {
        loop: true,
        breakpoints: {
            '(min-width: 360px)': {
                slides: { perView: 2, spacing: 30 },
                loop: true,
            },
            '(min-width: 640px)': {
                slides: { perView: 3, spacing: 30 },
                loop: true,
            },
            '(min-width: 1024px)': {
                slides: { perView: 4,  spacing: 50  },
                loop: true,
            },
        },
    },
    [
        (slider) => {
            let timeout;
            let mouseOver = false;

            function clearNextTimeout() {
                clearTimeout(timeout);
            }

            function nextTimeout() {
                clearTimeout(timeout);
                if (mouseOver) return;
                timeout = setTimeout(() => {
                    slider.next();
                }, 3000);
            }

            slider.on('created', () => {
                slider.container.addEventListener('mouseover', () => {
                    mouseOver = true;
                    clearNextTimeout();
                });
                slider.container.addEventListener('mouseout', () => {
                    mouseOver = false;
                    nextTimeout();
                });
                nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
        },
    ],
);
</script>

<template>
    <div
        v-if="logos"
        :class="{ 'bg-white': background_color === 'bg-white', 'bg-gray-100': background_color === 'bg-gray-lighter' }"
    >
        <div class="container relative py-12 md:py-16">
            <div class="h-full overflow-hidden pb-8">
                <div class="flex">
                    <h2 class="">
                        {{ title }}
                    </h2>
                </div>

                <div
                    ref="container"
                    class="keen-slider "
                >
                    <div
                        v-for="(logo, i) in [...logos,...logos]"
                        :key="i"
                        class="keen-slider__slide"
                        :class="`number-slide${i}`"
                    >
                        <div class="flex items-center justify-center rounded-2xl bg-white px-4 py-6">
                            <div class="flex h-[64px] items-center">
                                <ImgMedia
                                    :media="logo.image"
                                    classes="object-fit"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
@import url('keen-slider/keen-slider.css');
</style>
